import { render, staticRenderFns } from "./questionsList.vue?vue&type=template&id=b5ccf2fc"
import script from "./questionsList.vue?vue&type=script&lang=js"
export * from "./questionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports